import type { Node } from '@xyflow/react';
import type { OrgNode } from '@pms/shared';

/** Shared badge style for level-type pills (mirrors the original page styling). */
export const typeBadge =
  'inline-flex rounded-full border border-border/60 px-2 py-0.5 text-xs font-medium text-muted-foreground';

/** Fixed card dimensions handed to dagre for deterministic layout. */
export const NODE_WIDTH = 240;
export const NODE_HEIGHT = 96;

/** `data` payload carried by every React Flow node in the org chart. */
export interface OrgFlowNodeData {
  node: OrgNode;
  hasChildren: boolean;
  collapsed: boolean;
  childCount: number;
  isSelected: boolean;
  isMatch: boolean;
  searchActive: boolean;
  onSelect: (id: string) => void;
  onToggleCollapse: (id: string) => void;
  [key: string]: unknown;
}

/** Concrete React Flow node type used throughout the chart. */
export type OrgFlowNode = Node<OrgFlowNodeData, 'orgNode'>;

export interface OrgChartProps {
  tree: OrgNode[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  search: string;
  onSearchChange: (value: string) => void;
}
